import * as Sentry from '@sentry/react'

export const log = (message: string): void => {
  Sentry.captureMessage(message)
}

export const error = (err: object | string): void => {
  Sentry.captureException(typeof (err) === 'string' ? new Error(err) : err)
}
